import React from 'react'
import Dialog from '@mui/material/Dialog'
import { FormProvider, useForm } from 'react-hook-form'
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField
} from '@mui/material'
import SubmitButton from '../../commonUIComponents/SubmitButton'
import { useSnackbar } from 'notistack'
import { useNavigate } from 'react-router-dom'
import userService from '../../../services/userService'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'

const UpdateAccountPasswordModal = ({ open, onClose }) => {
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const methods = useForm({ mode: 'onChange' })
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = methods
  const password = methods.watch('password')

  const submitHandler = values => {
    const formValues = {
      currentPassword: values.currentPassword,
      newPassword: values.password
    }
    return userService.updatePassword(formValues)
      .then(res => {
        enqueueSnackbar('Successfully updated the password!', { variant: 'success' })
        navigate('/login')
      })
      .catch(err => enqueueSnackbar(err?.response?.data?.message, { variant: 'warning' }))
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(submitHandler)}>
          <Grid container>
            <Grid item xs={12}>
              <DialogTitle>Password</DialogTitle>
            </Grid>
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={(theme) => ({
                position: 'absolute',
                right: 8,
                top: 8,
                color: theme.palette.grey[500]
              })}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    label="Current password"
                    type="password"
                    {...register('currentPassword',
                      {
                        required: {
                          value: true,
                          message: 'Invalid Password'
                        }
                      }
                    )}
                    error={errors.password}
                    helperText={errors.password?.message}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Password"
                    type="password"
                    {...register('password',
                      {
                        required: {
                          value: true,
                          message: 'Invalid Password'
                        }
                      }
                    )}
                    error={errors.password}
                    helperText={errors.password?.message}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Confirm new password"
                    type="password"
                    {...register('confirmPassword',
                      {
                        required: {
                          value: true,
                          message: 'Invalid Password'
                        },
                        validate: value => {
                          if (password !== value) { return 'Passwords do not match!' }
                        }
                      }
                    )}
                    error={errors.confirmPassword}
                    helperText={errors.confirmPassword?.message}
                    fullWidth
                  />
                </Grid>
              </Grid>
              <DialogActions>
                <SubmitButton buttonLabel="Update Password" textAlign="right"/>
              </DialogActions>
            </DialogContent>
          </Grid>
        </form>
      </FormProvider>
    </Dialog>
  )
}

export default UpdateAccountPasswordModal
